<template>
  <section class="dashboard-card">
    <h3>Fouling Evaluation</h3>

    <div class="info-list">
      <div class="info-item">
        <span class="info-dot info-dot--blue" />
        <span>Evaluation of fouling slope</span>
      </div>

      <div class="info-item">
        <span class="info-dot info-dot--orange" />
        <span>Estimation on when to reach the deviation alert point</span>
      </div>

      <div class="info-item">
        <span class="info-dot info-dot--green" />
        <span>Estimation of UW inspection finances</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FoulingDetailsSection"
};
</script>

<style scoped>
.dashboard-card {
  background: var(--color-primary);
  border: 1px solid #dbe3ef;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.dashboard-card h3 {
  margin: 0 0 14px;
  color: #0f172a;
  font-size: 18px;
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
}

.info-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.info-dot--blue {
  background: #3b82f6;
}

.info-dot--orange {
  background: #f59e0b;
}

.info-dot--green {
  background: #22c55e;
}
</style>
